export const CONTACT_DETAIL_TYPES = [
    {
        value: 'name',
        label: 'שם',
    },
    {
        value: 'email',
        label: 'דוא"ל',
    },
    {
        value: 'phone',
        label: 'טלפון',
    },
    {
        value: 'whatsapp',
        label: 'ווטסאפ',
    },
]

const CONTACT_DETAIL_FIELD_LABELS = {
    type: 'סוג',
    name: 'תוית',
    value: 'ערך',
}

export function detailFieldLabelOf(field) {
    return CONTACT_DETAIL_FIELD_LABELS[field]
}

export const CONTACT_DETAIL_LABEL_OTHER = 'other'

const OTHER_LABEL = {
    value: CONTACT_DETAIL_LABEL_OTHER,
    label: 'אחר',
}

const PHONE_LABELS = [
    {
        value: 'general',
        label: 'כללי',
    },
    {
        value: 'mobile',
        label: 'נייד',
    },
    {
        value: 'office',
        label: 'משרד',
    },
    OTHER_LABEL,
]

export const CONTACT_DETAIL_LABELS = {
    name: [
        {
            value: 'full',
            label: 'מלא',
        },
        {
            value: 'first',
            label: 'פרטי',
        },
        {
            value: 'last',
            label: 'משפחה',
        },
        OTHER_LABEL,
    ],
    phone: PHONE_LABELS,
    email: [
        {
            value: 'work',
            label: 'עבודה',
        },
        {
            value: 'office',
            label: 'משרד',
        },
        {
            value: 'private',
            label: 'פרטי',
        },
        OTHER_LABEL,
    ],
    whatsapp: PHONE_LABELS,
}

export function detailLabelsOf(type) {
    return CONTACT_DETAIL_LABELS[type] ?? [OTHER_LABEL]
}

export function detailLabelChoiceOf(type, name) {
    if (name == null || name === '') {
        return {
            choice: '',
            other: '',
        }
    }

    const option = detailLabelsOf(type)
        .find((entry) => entry !== OTHER_LABEL && entry.label === name)

    return option != null
        ? {
            choice: option.value,
            other: '',
        }
        : {
            choice: CONTACT_DETAIL_LABEL_OTHER,
            other: name,
        }
}

export function detailLabelFrom(type, choice, other) {
    if (choice === CONTACT_DETAIL_LABEL_OTHER) {
        return other
    }

    return labelOf(detailLabelsOf(type), choice)
}

export const CONTACT_DETAIL_FLAGS = [
    {
        value: 'shareable',
        label: 'לשיתוף',
        tooltip: 'יוצג ללקוחות בהודעות הדוא״ל שהמשרד שולח',
    },
    {
        value: 'reachable',
        label: 'ליצירת קשר',
        tooltip: 'כתובת לפניות אל המשרד, למשל התראות על תשובות של לקוחות',
    },
    {
        value: 'marketing',
        label: 'לשיווק',
        tooltip: 'הלקוח הסכים לקבל דיוור שיווקי. הודעות נשלחות רק לכתובות המסומנות כך',
    },
]

export const CONTACT_RESTORE_LABEL = 'ביטול'

export const CONTACT_CONSENT_STATES = [
    {
        value: 'assertedByFirm',
    },
    {
        value: 'unsubscribed',
        label: 'הוסר מהתפוצה',
    },
]

export const CONTACT_ADDRESS_TYPES = [
    {
        value: 'mailing',
        label: 'כתובת',
    },
    {
        value: 'pobox',
        label: 'תא דואר',
    },
]

export function labelOf(entries, value) {
    return entries.find((entry) => entry.value === value)?.label ?? ''
}

const CONTACT_ADDRESS_FIELD_LABELS = {
    type: 'סוג',
    city: 'עיר',
    street: 'רחוב',
    number: 'מספר',
}

export function addressFieldLabelOf(field) {
    return CONTACT_ADDRESS_FIELD_LABELS[field]
}
